import {
  VisibilityOffOutlined as VisibilityOffOutlinedIcon,
  VisibilityOutlined as VisibilityOutlinedIcon,
} from '@mui/icons-material';
import { IconButton } from '@mui/material';
import React, { useCallback } from 'react';

interface IProps {
  isVisible: boolean;
  onChange: (isVisible: boolean) => void;
  isEditable?: boolean;
}

export const VisibilityToggle = React.forwardRef<HTMLButtonElement, IProps>(
  ({ isVisible, onChange, isEditable = true }, ref) => {
    const handleClick = useCallback(
      (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        onChange(!isVisible);
      },
      [isVisible, onChange],
    );

    return (
      <IconButton
        ref={ref}
        size="medium"
        onClick={isEditable ? handleClick : undefined}
        aria-label="toggle visibility"
        disableRipple
        sx={{
          padding: 0.625,
          cursor: isEditable ? 'pointer' : 'not-allowed',
        }}
        data-action="visibility_toggle"
      >
        {isVisible ? (
          <VisibilityOutlinedIcon fontSize="small" />
        ) : (
          <VisibilityOffOutlinedIcon fontSize="small" sx={{ color: 'primary.main' }} />
        )}
      </IconButton>
    );
  },
);
